import TransformIcon from "@mui/icons-material/Transform";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
const ProjectData = [
    {
      title: "Reform",
      description: "Effortlessly craft and share stunning forms through Webflow's intuitive prototype feature. Build with Next.js+TypeScript",
      icon: <TransformIcon className="h-8 w-8" />,
      link: "https://github.com/Amankohare0514/YourForm",
    },
    {
      title: "MyTube",
      description: 
      "Pioneered the development of My_tube, an innovative YouTube clone that pushes the boundaries of online video platforms.",
      icon: <SubscriptionsIcon className="h-8 w-8" />,
      link: "https://github.com/Amankohare0514/my_tube",
    },
    {
      title: "GitHub Finder",
      description:"Elevate your GitHub exploration by seamlessly discovering unique accounts and repositories, all while enjoying a touch of refined styling.",
      icon: <PersonSearchIcon className="h-8 w-8" />,
      link: "https://github.com/Amankohare0514/Github-Finder-with-styling",
    }
  ];

  export default ProjectData;